import HasGmField from './HasGmField.component';

export default HasGmField;
